<template>
  <el-date-picker
    v-model="value"
    type="month"
    format="yyyy 年 MM 月 "
    value-format="yyyy-MM"
    placeholder="选择月份"
    :clearable="false"
    :editable="false"
    :picker-options="{
      disabledDate(time) {
        return time.getTime() > Date.now();
      }
    }"
    @change="timeselect(value)"
  >
  </el-date-picker>
</template>

<script type="text/javascript">
export default {
  name: "datePick",
  data() {
    return {
      value: "" //默认时间
    };
  },
  methods: {
    init() {
      this.value = this.formatDateTime(new Date());
      this.$emit("getMonth", this.value);
    },
    //时间选择
    timeselect(value) {
      this.$emit("getMonth", this.value);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-input__icon {
  line-height: 34px;
}
</style>
